module.exports = React;


//////////////////
// WEBPACK FOOTER
// external "React"
// module id = 113
// module chunks = 0